import ExperimentContext from '@carvana/experiment/ExperimentProviderContext';
import { useCallback, useContext } from 'react';

import {
  recordActionClicked as recordClick,
  recordEventAndNavigate as recordAndNavigate,
  recordGenericEvent as recordEvent
} from '../../analytics/uiMetrics';

import type { EventActions } from '../../analytics/uiMetrics';

const useAnalyticEvent = () => {
  const { experiments } = useContext(ExperimentContext);

  const recordActionClicked = useCallback(
    (pageName: string, component: string, eventClickedData = {}, sendImmediately?: boolean) => {
      const customAttributes = { ...eventClickedData, experiments };
      return recordClick(pageName, component, customAttributes, sendImmediately);
    },
    [experiments]
  );

  const recordEventAndNavigate = useCallback(
    (
      event: React.MouseEvent<HTMLElement>,
      pageName: string,
      component: string,
      eventClickedData = {}
    ) => {
      const customAttributes = { ...eventClickedData, experiments };
      recordAndNavigate(event, pageName, component, customAttributes);
    },
    [experiments]
  );

  const recordGenericEvent = useCallback(
    (
      pageName: string,
      component: string,
      eventAction: EventActions,
      eventClickedData = {},
      sendImmediately = false
    ) => {
      const customAttributes = { ...eventClickedData, experiments };
      return recordEvent(pageName, component, eventAction, customAttributes, sendImmediately);
    },
    [experiments]
  );

  return {
    recordActionClicked,
    recordEventAndNavigate,
    recordGenericEvent
  };
};

export default useAnalyticEvent;
